import * as moment from 'moment-timezone';
import {NgbDateStruct, NgbTimeStruct} from '@ng-bootstrap/ng-bootstrap';

export class DateUtil {

  public static epochMilli2LocalMoment(epochMilli: number) {
    return epochMilli == null ? null : moment(epochMilli).utc().local();
  }

  public static epochMilli2LocalFromNow(epochMilli: number) {
    return epochMilli == null ? '' : moment(epochMilli).utc().local().fromNow();
  }

  public static moment2NgbDate(m: moment.Moment): NgbDateStruct {
    const mo: moment.MomentObjectOutput = m.toObject();
    return {
      year: mo.years,
      month: mo.months + 1,
      day: mo.date
    };
  }

  public static moment2NgbTime(m: moment.Moment): NgbTimeStruct {
    const mo: moment.MomentObjectOutput = m.toObject();
    return {
      hour: mo.hours,
      minute: mo.minutes,
      second: mo.seconds
    };
  }

  public static ngbDate2moment(d: NgbDateStruct): moment.Moment {
    const date = new Date(d.year, d.month - 1, d.day);
    return moment(date);
  }

  public static ngbDateTime2moment(d: NgbDateStruct, t: NgbTimeStruct): moment.Moment {
    const date = new Date(d.year, d.month - 1, d.day, t.hour, t.minute);
    return moment(date);
  }

  /** Convert an Ngb date + time picked in the UI into a Moment that
   *  represents **that exact wall-clock time in UTC**.  Using moment.utc
   *  guarantees the epoch sent to the backend is unambiguous, no matter
   *  what timezone the browser is running in.
   */
  public static ngbDateTimeLocal2Utc(
    d: NgbDateStruct,
    t: NgbTimeStruct,
    tzName: string
  ): moment.Moment {
    const local = moment.tz(
      {
        year: d.year,
        month: d.month - 1,
        day: d.day,
        hour: t.hour,
        minute: t.minute,
        second: (t as any).second ?? 0
      },
      tzName                     // interpret as wall-clock time **in** this zone
    );
    return local.clone().utc();  // convert to UTC for the backend
  }

}
